// import { createSelector } from 'reselect';
import { getCookieValue } from '../utils/cookie';
import {SPOTMENTOR_ENV} from "../config";

export const tokenSelector = state => state && state.auth.token;

export const refreshTokenSelector = () => getCookieValue(SPOTMENTOR_ENV);

export const isAuthenticatedSelector = () => !!refreshTokenSelector();

export const userSelector = state => state.auth.user;

export const userIdSelector = state =>
  state.auth.user && state.auth.user.user_id;

export const userNameSelector = state =>
  (state.auth.user && state.auth.user.name) || 'User';

export const userEmailSelector = state =>
  (state.auth.user && state.auth.user.email) || '';

export const userImageSelector = state =>
  state.auth.user && state.auth.user.profile_picture;

export const userRoleSelector = state =>
  state.auth.user &&
  state.auth.user.divisions &&
  state.auth.user.divisions.role;

export const orgIdSelector = state =>
  state.auth.user && state.auth.user.organization_id;

export const orgCtxSelector = state =>
  (state.auth.user && state.auth.user.context) || 'live';

export const isPlanGeneratedSelector = state =>
  state.auth.user && state.auth.user.learning_plans_generated;

export const authErrorSelector = state =>
  (state.auth.errorMessage &&
    'detail' in state.auth.errorMessage &&
    state.auth.errorMessage.detail) ||
  '';

export const isAdminSelector = state =>
  state.auth.user && state.auth.user.user_type <= 3;

export const hasCompletedPreTestSelector = state =>
  state.auth.user && state.auth.user.has_completed_pretest;

export const preTestIdSelector = state =>
  state.auth.user && state.auth.user.pretest_assessment_id;

export const isFirstLoginSelector = state =>
  state.auth.user && !!state.auth.user.is_first_login;

export const fcmTokenCreatedSelector = state =>
  state.auth.user && Object.values(state.auth.user.fcm_info || {}).some(d => d);



// WEBPACK FOOTER //
// ./src/selectors/auth.js